module.exports = __webpack_public_path__ + "img/avatar.375a5494.png";